<template>
  <div class="lineNewForm">
    <el-form ref="form" :disabled="!!lineId && view==='read'" :model="form" :rules="rules" label-width="96px"
             label-position="left">

      <el-form-item label="机构名称" prop="organizationId">
        <el-select @change="getStationsFn" v-model="form.organizationId" filterable :disabled="!!lineId">
          <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="出发地" prop="startStationName">
        <el-input v-model="form.startStationName" maxlength="60" placeholder="请输入出发地"/>
      </el-form-item>

      <el-form-item label="目的地" prop="endStationName">
        <el-input v-model="form.endStationName" maxlength="60" placeholder="请输入目的地"/>
      </el-form-item>


      <el-form-item label="上车站点" prop="startStations">
        <div v-if="!form.startStations || !form.startStations.length" style="color:#909399;font-size:12px;margin-bottom:6px">
          <i class="el-icon-info"></i> 从下方下拉框选择第一个上车站点后，可继续插入更多站点
        </div>
        <div class="flex-start" style="flex-wrap: wrap" v-if="form.startStations && form.startStations.length">
          <div style="margin:0 10px 10px 0" class="flex-start" @mouseleave="mouseleave('start',item,index)"
               @mouseenter="mouseenter('start',item,index)" v-for="(item,index) in form.startStations" :key="index">
            <el-tag style="margin-right: 4px" size="medium"
            >
              <span> {{ item.stationName }}</span>
              <el-tooltip v-if="item.showIcon || addActive === index" class="item" effect="dark" content="删除站点"
                          placement="top">
                <i @click.stop="deleteCodeFn('start',item,index)" class="el-icon-minus"
                   style="cursor: pointer;margin:0 4px"></i>
              </el-tooltip>
              <el-tooltip v-if="item.showIcon || addActive === index" class="item" effect="dark" content="插入站点"
                          placement="top">
                <i @click="addActive = index" class="el-icon-plus" style="cursor: pointer"></i>
              </el-tooltip>
            </el-tag>
            <el-select @blur="blurFn" v-if="index === addActive"
                       @change="addCodeFn('start',item,index)" v-model="mnemonicCodeNew"
                       filterable
                       placeholder="请选择上车站点">
              <el-option :disabled="form.startStations.map((h)=>h.stationCode).includes(it.stationCode)"
                         v-for="(it, i) in stationsList" :key="i" :value="it.stationCode"
                         :label="`${it.mnemonicCode}-${it.stationName}`">
              </el-option>
            </el-select>
          </div>
        </div>


        <el-select v-else @change="addCodeFn('start',{},0)" v-model="mnemonicCodeNew"
                   filterable
                   placeholder="请选择上车站点">
          <el-option v-for="(it, i) in stationsList" :key="i" :value="it.stationCode"
                     :label="`${it.mnemonicCode}-${it.stationName}`">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="下车站点" prop="endStations">
        <div v-if="!form.endStations || !form.endStations.length" style="color:#909399;font-size:12px;margin-bottom:6px">
          <i class="el-icon-info"></i> 从下方下拉框选择第一个下车站点后，可继续插入更多站点
        </div>
        <div class="flex-start" style="flex-wrap: wrap" v-if="form.endStations && form.endStations.length">
          <div class="flex-center" style="margin:0 10px 10px 0" @mouseleave="mouseleave('end',item,index)"
               @mouseenter="mouseenter('end',item,index)" v-for="(item,index) in form.endStations" :key="index">
            <el-tag style="margin-right: 4px" size="medium"
            >
              <span> {{ item.stationName }}</span>
              <el-tooltip v-if="item.showIcon || addActive2 === index" class="item" effect="dark" content="删除站点"
                          placement="top">
                <i @click.stop="deleteCodeFn('end',item,index)" class="el-icon-minus"
                   style="cursor: pointer;margin:0 4px"></i>
              </el-tooltip>
              <el-tooltip v-if="item.showIcon || addActive2 === index" class="item" effect="dark" content="插入站点"
                          placement="top">
                <i @click.stop="addActive2 = index" class="el-icon-plus" style="cursor: pointer"></i>
              </el-tooltip>
            </el-tag>
            <el-select @blur="blurFn" v-if="index === addActive2" @change="addCodeFn('end',item,index)"
                       v-model="mnemonicCodeNew"
                       filterable
                       placeholder="请选择下车站点">
              <el-option :disabled="form.endStations.map((h)=>h.stationCode).includes(it.stationCode)"
                         v-for="(it, i) in stationsList" :key="i" :value="it.stationCode"
                         :label="`${it.mnemonicCode}-${it.stationName}`">
              </el-option>
            </el-select>
          </div>
        </div>

        <el-select v-else @change="addCodeFn('end',{},0)" v-model="mnemonicCodeNew"
                   filterable
                   placeholder="请选择上车站点">
          <el-option v-for="(it, i) in stationsList" :key="i" :value="it.stationCode"
                     :label="`${it.mnemonicCode}-${it.stationName}`">
          </el-option>
        </el-select>
        <!--        <el-select @change="stationChange" multiple v-model="form.endStations" filterable placeholder="请选择下车站点">-->
        <!--          <el-option v-for="(item, i) in stationsList" :key="i" :value="item.mnemonicCode"-->
        <!--                     :label="`${item.mnemonicCode}-${item.stationName}`">-->
        <!--          </el-option>-->
        <!--        </el-select>-->
      </el-form-item>


      <el-form-item label="往返线路" prop="isReturn" v-if="!lineId">
        <el-switch v-model="form.isReturn" :active-value="1" :inactive-value="2" active-color="#13ce66"
                   inactive-color="#ccc"/>
      </el-form-item>
      <el-form-item label="分类标签" prop="labelId">
        <el-select v-model="form.labelId" filterable placeholder="请选择分类标签" :disabled="labelDisabled">
          <el-option v-for="(item, i) in labelList" :key="i" :value="item.id" :label="item.name">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="票价">
        <div v-if="!form.railFee || !form.railFee.length" style="color:#909399;font-size:12px;margin-bottom:6px">
          <i class="el-icon-info"></i> 选择上车和下车站点后，系统将自动生成票价矩阵，每个区间段均需填写票价
        </div>
        <el-table border :data="form.railFee">
          <el-table-column prop="startRailName" label="上车站点"></el-table-column>
          <el-table-column prop="endRailName" label="下车站点"></el-table-column>
          <el-table-column prop="fee" label="票价(元)" width="100px" v-slot="{ row, $index }">
            <el-form-item style="margin-bottom: 0;" label="" :prop="'railFee.' + $index + '.fee'"
                          :rules="[{ required: true, validator: validatorFee }]">
              <el-input v-model="row.fee"
                        @input="row.fee = row.fee.replace(/^0/g, '').replace(/^[1-9][0-9]{3,}/g, '999').replace(/(\d\d{0,2}\.?\d{0,2})?.*/g, '$1')"/>
            </el-form-item>

          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item label-width="0" v-if="view === 'edit'">
        <div class="main-form-btn">
          <el-button @click="$emit('handClose')">取消</el-button>
          <el-button type="primary" @click="actionFn" :loading="loading">确定</el-button>
        </div>
      </el-form-item>
    </el-form>
    <div class="main-form-btn" v-if="view === 'read'">
      <el-button @click="$emit('handClose')">关闭</el-button>
      <el-button type="primary" @click="view = 'edit'" :loading="loading">编辑</el-button>
    </div>

    <div class="main-form-btn" v-if="view === 'isOrder'">
      <div>
        <div class="flex" style="width: 100%;justify-content: space-between;">
          <div>
            <i class="el-icon-warning util-remark" style="font-size: 15px; padding-right: 6px"></i>
            <span class="util-remark">线路有未完成的订单，无法编辑</span>
          </div>
          <el-button @click="$emit('handClose')">关闭</el-button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "lineNewForm",
  props: ['lineId'],
  data() {
    return {
      labelList: [],
      labelDisabled: false,
      form: {
        organizationId: "",
        startStationName: "",
        endStationName: "",
        isReturn: 2,
        startStations: [],
        endStations: [],
        railFee: [],
        channelType: 2,
        labelId: "",
      },
      view: 'edit',
      rules: {
        organizationId: [{required: true, message: '请选择机构名称', trigger: ['blur', 'change']}],
        startStationName: [{required: true, message: '请输入出发地', trigger: ['blur', 'change']}],
        endStationName: [{required: true, message: '请输入目的地', trigger: ['blur', 'change']}],
        startStations: [{required: true, message: '请选择上车站点', trigger: ['blur', 'change']}],
        endStations: [{required: true, message: '请选择下车站点', trigger: ['blur', 'change']}],
      },
      stationsList: [],
      loading: false,
      mnemonicCodeNew: '',
      addActive: null,
      addActive2: null,

    }
  },
  async created() {
    this.getlabelList()
    await this.mixinOrganizations();
    this.$set(this.form, "organizationId", this.organizations[0].id);
    this.lineId && await this.getInitFn()

    await this.getStationsFn()
    this.lineId && this.getIsUpdate()
  },
  methods: {
    async getlabelList() {
      let url = "/api/v1/manage/lineLabel/labelList";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        if (data.data.length == 0) {
          this.labelList = [
            {
              value: null,
              label: "未配置标签，无标签可选",
              disabled: true,
            },
          ];
          this.labelDisabled = true;
        } else {
          this.labelList = data.data;
          this.labelDisabled = false;
        }
      }
    },

    /* 查询线路是否可以编辑 */
    async getIsUpdate() {
      console.log(3333, 111);
      let url = "/api/v1/manage/line/station/isUpdate/" + this.lineId;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.view = data.data ? 'read' : 'isOrder'
      }
    },
    blurFn() {
      setTimeout(() => {
        this.addActive = null
        this.addActive2 = null
      }, 100)
    },
    async actionFn() {
      const valid = await this.$refs.form.validate().catch(err => err);
      const url = "/api/v1/manage/line";
      if (typeof valid === 'boolean' && valid) {

        let startArr = []
        let endArr = []
        this.form.startStations.forEach((item, index) => {
          startArr.push({
            ...item,
            stationType: 1,
            railNo: index + 1
          })
        })

        this.form.endStations.forEach((item, index) => {
          delete item.id
          endArr.push({...item, stationType: 1, railNo: index + 1})
        })


        let station = [
          {
            ...this.form.startStations[0],
            id: this.lineId ? this.form.stationVoList[0].id : null,
            type: 1,
            stationType: this.form.startStations.length === 1 ? 1 : 2,

            stationRail: startArr,
          },
          {
            ...this.form.endStations[0],
            id: this.lineId ? this.form.stationVoList[1].id : null,
            type: 2,
            stationType: this.form.endStations.length === 1 ? 1 : 2,
            stationRail: endArr
          },
        ];

        this.loading = true
        const {code} = await this.$axios[this.lineId ? 'put' : 'post'](url, {
          ...this.form,
          labelName: this.form.labelId ? this.form.labelId : '',
          station: JSON.stringify(station),
          railFee: JSON.stringify(this.form.railFee)
        })
        this.loading = false
        if (code === 1) {
          this.$message.success('操作成功')
          this.$emit("handSuccess")
        }
      } else {
        this.$message.warning('请检查表单数据')
      }
    },
    // 选择排版
    stationChange() {
      let newRailFee = []
      this.form.startStations.forEach((item, num1) => {
        const start = this.stationsList.find((h) => h.stationCode == item.stationCode)
        this.form.endStations.forEach((it, num2) => {
          const end = this.stationsList.find((h) => h.stationCode == it.stationCode)

          const find = this.form.railFee.find((h) => (h.startRailName == start.stationName && h.endRailName == end.stationName))

          newRailFee.push({
            ...find,
            startStationType: 1,
            endStationType: 1,
            startRailName: start.stationName,
            endRailName: end.stationName,
            startStationCode: start.stationCode,
            endStationCode: end.stationCode,
            startRailNo: num1 + 1,
            endRailNo: num2 + 1,
            fee: find && find.fee || '',
          })
        })
      })
      this.$set(this.form, 'railFee', newRailFee)
    },

    validatorFee(rule, value, callback) {
      let index = rule.field.split('.')[1]
      if (!this.form.railFee[index].fee) {
        callback(new Error('请输入票价'));
      } else {
        callback();
      }
    },
    mouseenter(type, row, subIndex) {
      if (type === 'start') {
        this.$set(this.form.startStations, subIndex, {...row, showIcon: true})
      } else if (type === 'end') {
        this.$set(this.form.endStations, subIndex, {...row, showIcon: true})
      }
    },

    mouseleave(type, row, subIndex) {
      if (type === 'start') {
        this.$set(this.form.startStations, subIndex, {...row, showIcon: false})
      } else if (type === 'end') {
        this.$set(this.form.endStations, subIndex, {...row, showIcon: false})
      }
    },
    addCodeFn(type, row, subIndex) {

      if (this.view !== 'edit') return;
      if (!this.mnemonicCodeNew) return
      const find = this.stationsList.find((item) => item.stationCode === this.mnemonicCodeNew)

      if (type === 'start') {

        this.form.startStations.splice(subIndex + 1, 0, {...find})
        this.$refs.form.validateField('startStations')
      } else if (type === 'end') {
        this.form.endStations.splice(subIndex + 1, 0, {...find})
        this.$refs.form.validateField('endStations')
      }
      this.mnemonicCodeNew = null
      this.addActive = ''
      this.addActive2 = ''
      this.stationChange()
    },
    deleteCodeFn(type, row, subIndex) {
      if (this.view !== 'edit') return;
      if (type === 'start') {
        this.form.startStations.splice(subIndex, 1)
        this.$refs.form.validateField('startStations')
      } else if (type === 'end') {
        this.form.endStations.splice(subIndex, 1)
        this.$refs.form.validateField('endStations')
      }
      if (subIndex === this.addActive) {
        this.addActive = null
      }
      if (subIndex === this.addActive2) {
        this.addActive2 = null
      }
      this.stationChange()
    },
    async getInitFn() {
      const url = "/api/v1/manage/line/" + this.lineId;
      const {code, data} = await this.$axios.get(url)
      if (code === 1 && data) {
        this.form = {
          ...this.form,
          ...data,
          railFee: data.stationRailFee,
        }
        // mnemonicCode
        this.form.startStations = data.stationVoList[0].stationRail.map((item) => {
          return {
            ...item,
            showIcon: false
          }
        })
        this.form.endStations = data.stationVoList[1].stationRail.map((item) => {
          return {
            ...item,
            showIcon: false
          }
        })

      }
    },

    async getStationsFn() {
      if (!this.lineId) {
        this.form.endStations = []
        this.form.startStations = []
      }
      const url = "/api/v1/manage/station/base"
      const {code, data} = await this.$axios.get(url, {
        page: 1,
        size: 999,
        organizationId: this.form.organizationId
      })
      if (code === 1 && data) {
        this.stationsList = data
      }
    },
  }

}
</script>

<style scoped>

</style>